import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
// Libs
import styled from 'styled-components'

import { Page } from '../components/Page'
import { TLDRPartyRules } from '../components/Safety/TLDRPartyRules'
import { KeepCommunityStrong } from '../components/Safety/KeepCommunityStrong'
import { GetStarted } from '../components/GetStarted'
import { BowedHeroSection } from '../components/Sections/BowedHeroSection'
import { safetyPageStyles } from '../components/pageStyles/safetyPageStyles'

const PageContainer = styled(Page)`
  ${safetyPageStyles}
`

const SafetyPage = () => {
  const { t } = useTranslation('common')
  // ..
  return (
    <PageContainer>
      <BowedHeroSection
        bgImage={'/images/safteyHero.jpg'}
        smallHeader={t(`Safety and Privacy`, `Safety and Privacy`)}
        largeHeader={t(`safety-1707237734`, `Creating a safe space online`)}
        showCTA={false}
      />
      <TLDRPartyRules />
      <KeepCommunityStrong />
      <GetStarted />
    </PageContainer>
  )
}

// Export.
export default SafetyPage
export async function getStaticProps({ locale }) {
  const translations = await serverSideTranslations(locale, ['common'])
  return {
    props: {
      ...translations,
    },
  }
}
